<template>
  <div
    class="migrate-card"
    :class="{ 'is-compact': compact }"
  >

    <!-- header -->
    <header class="mg-head">
      <div class="mg-head-top">
        <span class="mg-badge">Thông báo chuyển đổi</span>
        <span class="mg-brand">AVERADATA</span>
      </div>
      <h1 class="mg-title">FastProxy <span class="mg-arrow">→</span> AveraData</h1>
      <p class="mg-sub">Chuỗi kết nối chỉ khác tên miền · Giữ nguyên danh sách port</p>
      <p class="mg-lead">
        Cảm ơn bạn đã đồng hành cùng FastProxy. Từ 15/08/2026 chúng tôi ngừng bán gói mới trên FastProxy
        và chuyển sang AveraData — hệ thống nâng cấp thay thế hoàn toàn, cùng nguồn IP pools cao cấp và cao cấp hơn:
      </p>
    </header>

    <div class="mg-body">

      <!-- so sánh -->
      <div class="mg-table-wrap">
        <table class="mg-table">
          <thead>
            <tr>
              <th class="c-item">Hạng mục</th>
              <th class="c-old">FastProxy</th>
              <th class="c-new">AveraData</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, i) in rows"
              :key="i"
            >
              <td class="c-item">
                <span class="i-name">{{ row.item }}</span>
                <small
                  v-if="row.note"
                  class="i-note"
                >{{ row.note }}</small>
              </td>
              <td class="c-old">{{ row.old }}</td>
              <td
                class="c-new"
                :class="row.tone"
              >{{ row.new }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- chuỗi kết nối -->
      <section class="mg-conn">
        <h2 class="mg-conn-title">Chuỗi kết nối chỉ khác tên miền — giữ nguyên port và cấu trúc</h2>
        <code class="mg-code is-old">socks5://zone-{username}-port-10001:{password}@get.fastproxy.vip:2086</code>
        <code class="mg-code is-new">socks5://zone-{username}-port-10001:{password}@get.averadata.com:2086</code>
      </section>

      <!-- mốc thời gian -->
      <p class="mg-notice">
        FastProxy ngừng bán gói mới từ 15/08/2026, ngừng gia hạn từ 15/09/2026.<br>
        Gói đang chạy vẫn hoạt động bình thường tới hết hạn.
      </p>
    </div>

    <!-- footer CTA -->
    <footer class="mg-foot">
      <div class="mg-foot-left">
        <a
          class="mg-foot-domain"
          :href="targetUrl"
          target="_blank"
          rel="noopener"
        >averadata.com</a>
        <span class="mg-foot-note">Mã <b>FAST_MIGRATE</b> giảm 10% — đến 15/09/2026</span>
      </div>
      <a
        class="mg-foot-btn"
        :href="registerUrl"
        target="_blank"
        rel="noopener"
      >Chuyển ngay</a>
    </footer>

  </div>
</template>

<script>
export default {
  props: {
    // bản gọn cho modal: thu nhỏ chữ và giãn cách
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      targetUrl: 'https://averadata.com',
      registerUrl: 'https://averadata.com/register',
      rows: [
        {
          item: 'Nguồn IP pools cao cấp', old: 'Như nhau', new: 'Bổ sung liên tục', tone: 'is-good',
        },
        {
          item: 'Định tuyến & tài khoản thành viên', old: 'Như nhau', new: 'Như nhau', tone: 'is-same',
        },
        {
          item: 'Cộng dồn lưu lượng chưa dùng', note: 'khi gia hạn, có điều kiện', old: 'Không có', new: 'Miễn phí', tone: 'is-good',
        },
        {
          item: 'Block Services', note: 'tắt 26 nhóm dịch vụ để giảm lưu lượng', old: 'Không có', new: 'Có', tone: 'is-good',
        },
        {
          item: 'Mua 2 tháng −5% · 3 tháng −10%', old: 'Không có', new: 'Có', tone: 'is-good',
        },
        {
          item: 'Mã giảm giá riêng cho khách FastProxy', old: 'Không có', new: 'Giảm 10%', tone: 'is-good',
        },
        {
          item: 'Phát triển tính năng · bổ sung IP', old: 'Đã dừng', new: 'Liên tục', tone: 'is-good',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
$mg-blue: #1a73e8;
$mg-blue-dark: #0b3f91;
$mg-blue-mid: #1560c4;
$mg-green: #1e8e3e;
$mg-line: #e5eaf2;
$mg-muted: #6b7280;

.migrate-card {
  width: 100%;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}

/* ---------- header ---------- */
.mg-head {
  background: #e9f2fd;
  padding: 2.25rem 2.5rem 2rem;
}

.mg-head-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
}

.mg-badge {
  background: $mg-blue;
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.7rem 1.5rem;
  border-radius: 2rem;
}

.mg-brand {
  color: $mg-blue-mid;
  font-weight: 700;
  font-size: 1.15rem;
  letter-spacing: 0.08em;
}

.mg-title {
  color: $mg-blue-dark;
  font-weight: 700;
  font-size: 2.75rem;
  line-height: 1.15;
  margin-bottom: 0.5rem;
}

.mg-arrow {
  font-weight: 400;
}

.mg-sub {
  color: $mg-blue-mid;
  font-size: 1.05rem;
  margin-bottom: 0;
}

.mg-lead {
  color: #2c4a72;
  font-size: 1.05rem;
  line-height: 1.75;
  margin: 1.25rem 0 0;
}

/* ---------- body ---------- */
.mg-body {
  padding: 1.5rem 2.5rem 2rem;
}

.mg-table-wrap {
  overflow-x: auto;
}

.mg-table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;

  th,
  td {
    padding: 1.15rem 1.25rem;
    text-align: left;
    vertical-align: middle;
  }

  thead th {
    text-transform: uppercase;
    letter-spacing: 0.07em;
    font-size: 0.85rem;
    font-weight: 500;
    color: #7b879d;
    border-bottom: 1px solid $mg-line;
  }

  tbody td {
    border-bottom: 1px solid $mg-line;
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }

  .c-old {
    width: 20%;
    color: $mg-muted;
  }

  /* cột AveraData được tô nền nhạt suốt chiều dọc */
  .c-new {
    width: 22%;
    background: #eff5fe;
    font-weight: 700;
    color: $mg-green;
  }

  thead .c-new {
    color: $mg-blue-mid;
    font-weight: 700;
  }

  .c-new.is-same {
    color: $mg-blue;
  }
}

.i-name {
  display: block;
  color: #1f2937;
  font-size: 1.05rem;
}

.i-note {
  display: block;
  color: #8a94a6;
  font-size: 0.85rem;
  margin-top: 0.15rem;
}

/* ---------- chuỗi kết nối ---------- */
.mg-conn {
  margin-top: 1.75rem;
  border: 1px solid #bcd7f7;
  border-radius: 8px;
  padding: 1.25rem 1.5rem;
}

.mg-conn-title {
  color: $mg-blue-mid;
  font-weight: 700;
  font-size: 1.05rem;
  margin-bottom: 1rem;
}

.mg-code {
  display: block;
  font-family: SFMono-Regular, Menlo, Consolas, 'Courier New', monospace;
  font-size: 0.9rem;
  word-break: break-all;
  padding: 0.35rem 0;
  background: none;

  &.is-old {
    color: #9aa4b2;
  }

  &.is-new {
    color: #24303f;
  }
}

/* ---------- mốc thời gian ---------- */
.mg-notice {
  margin: 1.25rem 0 0;
  color: #8a7440;
  line-height: 1.7;
}

/* ---------- footer ---------- */
.mg-foot {
  background: $mg-blue;
  padding: 1.5rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  flex-wrap: wrap;
}

.mg-foot-domain {
  display: block;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.2;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
}

.mg-foot-note {
  display: block;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
  margin-top: 0.15rem;
}

.mg-foot-btn {
  background: #fff;
  color: $mg-blue-mid;
  font-weight: 600;
  font-size: 1.05rem;
  padding: 0.85rem 2.5rem;
  border-radius: 4px;
  white-space: nowrap;

  &:hover {
    color: $mg-blue-dark;
    background: #f2f7ff;
  }
}

/* ---------- dark layout ---------- */
.dark-layout {
  .migrate-card {
    background: #283046;
  }

  .mg-head {
    background: #161d31;
  }

  .mg-title {
    color: #d0d2d6;
  }

  .mg-lead {
    color: #b4b7bd;
  }

  .mg-table {
    th,
    td {
      border-color: #3b4253;
    }

    .c-new {
      background: rgba(26, 115, 232, 0.12);
    }
  }

  .i-name {
    color: #d0d2d6;
  }

  .mg-conn {
    border-color: #3b4253;
  }

  .mg-code.is-new {
    color: #d0d2d6;
  }
}

/* ---------- bản gọn (dùng trong modal) ---------- */
.migrate-card.is-compact {
  .mg-head {
    padding: 1.25rem 1.5rem;
  }

  .mg-head-top {
    margin-bottom: 0.85rem;
  }

  .mg-badge {
    font-size: 0.8rem;
    padding: 0.4rem 1rem;
  }

  .mg-brand {
    font-size: 0.95rem;
  }

  .mg-title {
    font-size: 1.6rem;
    margin-bottom: 0.25rem;
  }

  .mg-sub {
    font-size: 0.9rem;
  }

  .mg-lead {
    font-size: 0.9rem;
    line-height: 1.6;
    margin-top: 0.65rem;
  }

  .mg-body {
    padding: 1rem 1.5rem 1.25rem;
  }

  .mg-table {
    min-width: 520px;

    th,
    td {
      padding: 0.55rem 0.75rem;
    }

    thead th {
      font-size: 0.72rem;
    }
  }

  .i-name {
    font-size: 0.9rem;
  }

  .i-note {
    font-size: 0.76rem;
  }

  .mg-conn {
    margin-top: 1rem;
    padding: 0.85rem 1rem;
  }

  .mg-conn-title {
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }

  .mg-code {
    font-size: 0.76rem;
    padding: 0.2rem 0;
  }

  .mg-notice {
    margin-top: 0.85rem;
    font-size: 0.85rem;
    line-height: 1.6;
  }

  .mg-foot {
    padding: 0.9rem 1.5rem;
  }

  .mg-foot-domain {
    font-size: 1.15rem;
  }

  .mg-foot-note {
    font-size: 0.8rem;
  }

  .mg-foot-btn {
    font-size: 0.9rem;
    padding: 0.55rem 1.5rem;
  }
}

/* ---------- responsive ---------- */
@media (max-width: 767.98px) {
  .mg-head {
    padding: 1.5rem 1.25rem;
  }

  .mg-title {
    font-size: 1.9rem;
  }

  .mg-body {
    padding: 1.25rem;
  }

  .mg-foot {
    padding: 1.25rem;
  }

  .mg-foot-btn {
    width: 100%;
    text-align: center;
  }
}
</style>
